import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Box,
  Button,
} from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Header from "./Header";

const areaImages = {
  Pune: "https://...jpg",
  Hadapsar:
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTeoR5ubkXH3XaDQ1qMXL4VlqASNFGxGQJwJw&s",
  Wagholi:
    "https://i.ytimg.com/vi/LAfAzP1y6hU/hq720.jpg?sqp=-oaymwEhCK4FEIIDSFryq4qpAxMIARUAAAAAGAElAADIQj0AgKJD&rs=AOn4CLBBpV-NmeAfl7RM7irEn2o9CvB3Qg",
  Kharadi:
    "https://i.ytimg.com/vi/LAfAzP1y6hU/hq720.jpg?sqp=-oaymwEhCK4FEIIDSFryq4qpAxMIARUAAAAAGAElAADIQj0AgKJD&rs=AOn4CLBBpV-NmeAfl7RM7irEn2o9CvB3Qg",
  Katraj:
    "https://content.jdmagicbox.com/v2/comp/pune/q5/020pxx20.xx20.240808083912.y3q5/catalogue/ekab-hospitality-pune-guest-house-uva8dnfc92-250.jpg",
  Baner: "https://...",
};

const AreaInService = () => {
  const [areas, setAreas] = useState([]);
  const [showAll, setShowAll] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get("https://sakhisshop.com/api/shops/available-areas")
      .then((res) => setAreas(res.data))
      .catch((err) => console.error("Failed to fetch areas", err));
  }, []);

  const visibleAreas = showAll ? areas : areas.slice(0, 4); // 👈 Show first 4 or all

  return (
    <Container sx={{ py: 7 }}>
      <Header />
      <Box textAlign="center" mb={5}>
        <LocationOnIcon fontSize="large" color="error" />
        <Typography variant="h4" fontWeight={600}>
          📍 Areas We Serve
        </Typography>
        <Typography variant="subtitle1" color="text.secondary">
          Click on an area to view available shops
        </Typography>
      </Box>

      <Grid container spacing={4}>
        {visibleAreas.map((area, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card
              onClick={() => navigate(`/shops-in-area/${area}`)}
              sx={{
                height: "100%",
                cursor: "pointer",
                borderRadius: 3,
                overflow: "hidden",
                boxShadow: 4,
                transition: "transform 0.3s ease",
                "&:hover": { transform: "scale(1.03)" },
              }}
            >
              <CardMedia
                component="img"
                height="200"
                image={areaImages[area] || areaImages["Pune"]}
                alt={area}
              />
              <CardContent sx={{ textAlign: "center" }}>
                <Typography
                  variant="h6"
                  fontWeight={600}
                  sx={{ fontFamily: "Poppins" }}
                >
                  {area}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {areas.length > 3 && (
        <Box textAlign="center" mt={4}>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => setShowAll(!showAll)}
          >
            {showAll ? "Show Less" : "View More"}
          </Button>
        </Box>
      )}
    </Container>
  );
};

export default AreaInService;
